import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable(
    {
        providedIn: 'root'
    }
)
export class CustomErrorHandlerService extends ErrorHandler {
    headers: any = new HttpHeaders({ 'Content-Type': 'application/json', 'Accept': '*/*' });
    access_token: any = localStorage.getItem('adminToken') || 'request';
    constructor(private http: HttpClient) {
        super();
    }

    handleError(error) {
        // Here you can provide whatever logging you want
        super.handleError(error);
        let api_url = environment.request_url; //localStorage.getItem('request_url');
        this.http.post<any>(api_url + 'split_frontend_error', { error: error.stack, access_token: this.access_token, url: window.location.href }, { headers: this.headers })
            .subscribe(response => {
            });
    }
}